<script>
import appConfig from '@src/app.config'

// import LogRocket from 'logrocket'
// LogRocket.init('xlza4e/insight-wwdmm')

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters['auth/loggedIn']
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <keep-alive>
      <RouterView
        v-if="$route.meta.keepAlive && userLoggedIn"
        :key="$route.fullPath"
      />
    </keep-alive>

    <RouterView v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// @import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
// @import '@design';

.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  background: #fff;
}
.vs__dropdown-toggle {
  background: #fff !important;
  border: 1px solid rgb(222, 226, 230) !important;
  border-radius: 4px;
  white-space: normal;
  height: calc(1.5em + 0.875rem + 2px) !important;
}
@import 'bootstrap/scss/bootstrap';
@import 'bootstrap-vue/src/index.scss';

@import './assets/scss/theme.scss';

// Customize the look and feel of the grid with Sass variables
// Up-to-date list of variables is available here: http://www.ag-grid.com/javascript-grid-styling/#customizing-sass-variables

// changes the default icon color
$icon-color: #03a9f4;

$row-height: 14px;

$font-family: 'Montserrat';
$font-weight: 600;
$font-size: 0.82rem !default;

// changes the selected checkbox check mark color
$accent-color: #03a9f4;

$header-height: 40px;
$row-height: 38px;
$row-border-width: 1px;
$hover-color: cornsilk;

$ag-range-selected-color-1: rgb(250, 235, 215);
$ag-range-selected-color-2: darken($ag-range-selected-color-1, 10%);
$ag-range-selected-color-3: darken($ag-range-selected-color-1, 20%);
$ag-range-selected-color-4: darken($ag-range-selected-color-1, 30%);

@import '~ag-grid-community/src/styles/ag-grid.scss';
@import '~ag-grid-community/src/styles/ag-theme-balham/sass/ag-theme-balham.scss';
@import 'vue-select/src/scss/vue-select.scss';

.ag-theme-balham {
  .ag-icon {
    // font-awesome Free has font-weight bold
    font-weight: bold;
    &.ag-icon-checkbox-checked,
    &.ag-icon-checkbox-indeterminate,
    &.ag-icon-checkbox-unchecked {
      background-color: transparent;
      border-radius: 0;
      color: $icon-color;
    }
  }
}

.uc {
  text-transform: uppercase !important;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

// body {
//   background: $color-body-bg;
// }
// #app {
//   @extend %typography-small;
// }

// // ===
// // Base element styles
// // ===

// a,
// a:visited {
//   color: $color-link-text;
// }

// h1 {
//   @extend %typography-xxlarge;
// }

// h2 {
//   @extend %typography-xlarge;
// }

// h3 {
//   @extend %typography-large;
// }

// h4 {
//   @extend %typography-medium;
// }

// h5,
// h6 {
//   @extend %typography-small;
// }

// ===
// Vendor
// ===

#nprogress .bar {
  background: red;
}

$fred-success: #88af2c;
$dcs-primary: #009688;
$fred-dark: #0f141c;

$theme-colors: (
  'primary': $fred-success,
  'success': $fred-success,
  '$dark': $fred-dark,
  'danger': #ff4136,
);

$font-size-base: 12px; // this changes the font-size throughout bootstrap
$font-family-sans-serif: 'Montserrat', sans-serif;
$font-size-base: 1rem;
$line-height-base: 1.2;

@import '~ag-grid-community/src/styles/ag-grid.scss';
@import '~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin';

.ag-theme-alpine {
  @include ag-theme-alpine(
    (
      font-family: (
        'Montserrat',
        sans-serif,
      ),
      odd-row-background-color: #e9ecf3,
      // row-border-color: transparent,
        header-height: 35px,
      row-height: 32px,
      // row-hover-color: null,
        checkbox-checked-color: $fred-dark,
      range-selection-border-color: $fred-success,
      // header-background-color: $fred-dark,
        // header-foreground-color: #fff,
        row-hover-color: transparentize($fred-success, 0.75),
      range-selection-background-color: transparentize($fred-success, 0.7),
      // Color to draw around selected cell ranges
        // range-selection-border-color: ag-derived(foreground-color),
        // Background color of selected rows in the grid and in dropdown menus
        selected-row-background-color: transparentize($fred-success, 0.1),
    )
  );
  .ag-cell,
  .ag-header-cell {
    display: flex;

    align-items: center;

    &.center {
      justify-content: center;
    }
  }
  .ag-cell img {
    max-height: 45px;
    width: 100%;
  }
  .ag-root-wrapper {
    border-radius: 0px;
    border-width: 0;
  }
  .ag-header-cell,
  .ag-header-group-cell {
    padding-right: 0 !important;
  }
  .ag-row {
    font-weight: 500;
  }
  .ag-header-cell {
    text-transform: uppercase;
  }
  .ag-row-selected {
    color: #fff !important;
  }
}

.dark {
  $dark-bg: desaturate(lighten($fred-dark, 10), 20%);
  .ag-theme-alpine {
    @include ag-theme-alpine(
      (
        font-family: (
          'Montserrat',
          sans-serif,
        ),
        odd-row-background-color: lighten($dark-bg, 3),
        foreground-color: #fff,
        background-color: $dark-bg,
        // row-border-color: transparent,
          header-height: 35px,
        row-height: 32px,
        // row-hover-color: null,
          checkbox-checked-color: $fred-dark,
        range-selection-border-color: $dcs-primary,
        header-background-color: $fred-dark,
        header-foreground-color: #fff,
        row-hover-color: transparentize($dcs-primary, 0.75),
        range-selection-background-color: transparentize($dcs-primary, 0.7),
        // Color to draw around selected cell ranges
          // range-selection-border-color: ag-derived(foreground-color),
          // Background color of selected rows in the grid and in dropdown menus
          selected-row-background-color: transparentize($dcs-primary, 0.1),
        border-color: lighten($dark-bg, 10),
        row-border-color: lighten($dark-bg, 10),
      )
    );
    .ag-root-wrapper {
      border-radius: 0px;
      border-width: 0;
    }
    .ag-header-cell,
    .ag-header-group-cell {
      padding-right: 0 !important;
    }
    .ag-row {
      font-weight: 500;
    }
    .ag-header-cell {
      text-transform: uppercase;
    }
    .ag-row-selected {
      color: #fff !important;
    }
  }
}

// start
$height: 38px;
.toggleWrapper {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  overflow: hidden;
  // -webkit-transform: translate3d(-50%, -50%, 0);
  // transform: translate3d(-50%, -50%, 0);
  // box-shadow: 3px 3px 3px 0px #00000026;
  height: $height;
  border-radius: 6px;
}
.toggleWrapper input {
  position: absolute;
  left: -99em;
}

.toggle {
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: 220px;
  height: $height;
  background: #d21626;
  border-radius: 5px;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
}
.toggle:before,
.toggle:after {
  position: absolute;
  line-height: $height;
  font-size: 12px;
  z-index: 2;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.toggle:before {
  content: 'DISABLED';
  left: 21px;
  color: #d21626;
}
.toggle:after {
  content: 'ENABLED';
  right: 20px;
  color: #fff;
}

.toggle__handler {
  display: inline-block;
  position: relative;
  z-index: 1;
  background: #fff;
  width: 100px;
  height: calc(#{$height} - 6px);
  border-radius: 3px;
  top: 3px;
  left: 3px;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);

  transform: translateX(0px);
}

input:checked + .toggle {
  background: $fred-success;
}
input:checked + .toggle:before {
  color: #fff;
}
input:checked + .toggle:after {
  color: $fred-success;
}
input:checked + .toggle .toggle__handler {
  width: 95px;

  transform: translateX(119px);
  border-color: #fff;
}

.enabled {
  background: $fred-success;

  width: 100%;
  color: white;
}

.disabled {
  background: #d21626;

  width: 100%;
  color: white;
}

// end
</style>
